import {StatusHistory} from '@gatewee/types/system';
import {Domain} from './domain';
import {Recipient} from './recipient';

export enum PixKeyType {
  RANDOM_KEY = 'random_key',
  DOCUMENT = 'document',
  PHONE = 'phone',
  EMAIL = 'email',
}

export enum BankAccountType {
  CHECKING = 'checking',
  SAVINGS = 'savings',
}

export enum RecipientBankAccountStatus {
  PENDING_APPROVAL = 'pending_approval',
  ACTIVE = 'active',
  REJECTED = 'rejected',
  BLOCKED = 'blocked',
}

export interface RecipientBankAccount {
  id: number;

  pixKeyType: PixKeyType;

  pixKey: string;

  holderName: string;

  holderDocument: string;

  compeCode?: string;

  agency?: string;

  agencyDigit?: string;

  account?: string;

  accountType?: BankAccountType;

  accountDigit?: string;

  /** DICT end-to-end id returned by the PIX key lookup, when the account was created from it. */
  pixKeyE2eId?: string;

  /** ISPB code of the holder's institution, returned by the PIX key lookup. */
  ispbCode?: string;

  recipient: Recipient;

  domain: Domain;

  createdAt: Date;

  updateAt: Date;

  default: boolean;

  status: RecipientBankAccountStatus;

  statusHistory: StatusHistory[];
}
